import { resolveMapIconTone } from "../containers/Dashboard/dashboardIconTone";

export function machineMapIconUrl(iconName, tone) {
  const folder = tone || "offline";
  const name = iconName || "tractor";
  try {
    return require(`../assets/traccar/${folder}/${name}.svg`);
  } catch (error) {
    try {
      return require(`../assets/traccar/${folder}/tractor.svg`);
    } catch (fallbackError) {
      return require("../assets/traccar/offline/tractor.svg");
    }
  }
}

export function pedestrianMapIconUrl(tone) {
  const folder = tone || "offline";
  try {
    return require(`../assets/platform/${folder}/pedestrian.svg`);
  } catch (error) {
    return require("../assets/platform/offline/pedestrian.svg");
  }
}

export function isPedestrianMapIcon(equipment) {
  const name = String((equipment && equipment.traccar_ico) || "").toLowerCase();
  return (
    name === "person" ||
    name === "pedestrian" ||
    (equipment && equipment.iconKind === "pedestrian")
  );
}

export function resolveEquipmentMapIconUrl(equipment) {
  const assumed = Boolean(
    equipment &&
      (equipment.assumed ||
        equipment.operator_label ||
        isPedestrianMapIcon(equipment))
  );
  const tone = resolveMapIconTone({
    assumed,
    speed: equipment && equipment.speed,
    lastMovedAt:
      equipment && (equipment.lastMovedAt || equipment.last_connection),
    reportedAt: equipment && equipment.last_connection,
    assumedAt: equipment && (equipment.assumedAt || equipment.last_connection),
    telemetryReleasedAt: equipment && equipment.telemetryReleasedAt,
    telemetryPausedAt: equipment && equipment.telemetryPausedAt,
    fallbackOffline: equipment && equipment.machine_status === "offline",
  });

  if (isPedestrianMapIcon(equipment)) {
    return pedestrianMapIconUrl(tone);
  }
  return machineMapIconUrl(equipment && equipment.traccar_ico, tone);
}
